import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";

function PublicLayout() {
  return (
    <>
      <Header />
      <main style={{ paddingTop: "60px", minHeight: "calc(100vh - 170px)" }}>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default PublicLayout;
